<ng-container *ngIf="liveLicense; else demoLicense">
  <p class="mb-2">
    <transloco id="c4f8d896-3614-44f0-9353-4532ac19f039" key="marketplace.asset.subscriptionCancelConfirmationText.weHaveSentEmail"> </transloco>
  </p>
  <p>
    <transloco
      id="2f21f092-42bd-4bc8-b00b-5f4dee0e35aa"
      [key]="
        terminationDate && endOfPeriod && terminationDate > endOfPeriod
          ? 'marketplace.asset.subscriptionCancelConfirmationText.liveLicenseWithFurtherPayments'
          : 'marketplace.asset.subscriptionCancelConfirmationText.liveLicenseWithoutFurtherPayments'
      "
      [params]="{
        productName,
        endOfPeriod: endOfPeriod ? (endOfPeriod | translocoDate: { dateStyle: 'medium' }) : '',
        terminationDate: terminationDate ? (terminationDate | translocoDate: { dateStyle: 'medium' }) : ''
      }">
    </transloco>
  </p>
</ng-container>
<ng-template #demoLicense
  ><p class="mb-0">{{ 'marketplace.asset.subscriptionCancelConfirmationText.demoLicense' | transloco }}</p></ng-template
>
